import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AppContext from '../../../context/AppContext';
import Checkbox from '../../../shared/Checkbox';
import Item from '../../../shared/TechSkills/Item';
import AddItem from '../../../shared/TechSkills/AddItem';
import DragNDropList from '../../../shared/DragNDropList';
import config from '../../../config';

const IOsTechnologiesTab = ({ data, onChange }) => {

  const context = useContext(AppContext);
  const { dispatch } = context;
  const { t } = useTranslation('leftSidebar');

  useEffect(() => {
    if (!('iOsTechnologies' in data)) {
      dispatch({
        type: 'migrate_section',
        payload: {
          key: 'iOsTechnologies',
          value: {
            enable: false,
            heading: 'iOS Technologies',
            items: [],
          },
        },
      });
    }
  }, [data, dispatch]);

  return (
    'iOsTechnologies' in data && (
      <>
        <div className="mb23 flex justify-between items-center">
          <div className="title_tab">{t('iOsTechnologies.title.label')}</div>

          <div className="col-span-1">
            <Checkbox
              checked={data.iOsTechnologies.enable}
              onChange={v => onChange('data.iOsTechnologies.enable', v)}
            />
          </div>
        </div>

        <hr className="my-6" />

        <DragNDropList
          data={data}
          dispatch={dispatch}
          onChange={onChange}
          type="iOsTechnologies"
        >
          {data.iOsTechnologies.items.map((x, index) => (
            <Item
              item={x}
              key={x.id}
              index={index}
              onChange={onChange}
              dispatch={dispatch}
              first={index === 0}
              last={index === data.iOsTechnologies.items.length - 1}
              type='iOsTechnologies'
              idTab={config.TECH_SKILLS_TABS.iOsTechnologies}
            />
          ))}          
        </DragNDropList>


        <AddItem heading={data.iOsTechnologies.heading} dispatch={dispatch} type='iOsTechnologies' idTab={config.TECH_SKILLS_TABS.iOsTechnologies} />
      </>
    )
  );
};

export default IOsTechnologiesTab;
